import React from 'react'
import PropTypes from 'prop-types'
import { PromotionListItem } from './PromotionListItem'
import sortBy from 'lodash/sortBy'


const PromotionItems = (props) => (
  <ul className={`promotion-items columns-container ${props.textAlignmentClass}`}>
    {
      sortBy(props.items, 'key').map((item, index) => {
        return (
          <PromotionListItem
            showIcons={props.showIcons}
            key={index}
            item={item}
            themeColorHex={props.themeColorHex}
            itemInRowClass={props.itemInRowClass}
            textAlignmentClass={props.textAlignmentClass}
            iconSizeClass={props.iconSizeClass} />
        )
      })
    }
  </ul>
)

PromotionItems.propTypes = {
  themeColorHex: PropTypes.string.isRequired,
  items: PropTypes.object,
  itemInRowClass: PropTypes.string.isRequired,
  showIcons: PropTypes.bool.isRequired,
  textAlignmentClass: PropTypes.string,
  iconSizeClass: PropTypes.string
}

export default PromotionItems
